"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
const EQuestionCategory_1 = require("../../../../enums/Project/Config/Vote/EQuestionCategory");
const Resource_1 = __importDefault(require("../../../Resource"));
const ChoiceResponseResource_1 = __importDefault(require("../../../Choice/ChoiceResponseResource"));
class QuestionResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.title_en = null;
        this.content_en = null;
    }
}
exports.default = QuestionResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], QuestionResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], QuestionResponseResource.prototype, "content", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], QuestionResponseResource.prototype, "title_en", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], QuestionResponseResource.prototype, "content_en", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], QuestionResponseResource.prototype, "voted", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], QuestionResponseResource.prototype, "isActive", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], QuestionResponseResource.prototype, "category", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], QuestionResponseResource.prototype, "endsAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => ChoiceResponseResource_1.default),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], QuestionResponseResource.prototype, "choices", void 0);
